import { validators } from 'views/declarations/uk/export/validations/validations';
import { ICS2ArrivalData } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';

const MARITIME = '1';
const AIR = '4';

const party = (identificationRequired: boolean) => ({
    childValidators: {
        identificationNumber: [...(identificationRequired ? [validators.required()] : []), validators.maxLength(17)],
        communication: {
            childValidators: {
                identifier: [validators.required(), validators.maxLength(512)],
                type: [validators.required(), validators.maxLength(3)],
            },
            stopAtNull: true,
        },
    },
    ...(identificationRequired ? {} : { stopAtNull: true }),
});

export const ics2ArrivalNotificationValidation = (values?: ICS2ArrivalData) => {
    const mode = values?.activeBorderTransportMeans?.modeOfTransport;

    return {
        childValidators: {
            reference: [validators.maxLength(255)],
            personNotifyingTheArrival: party(true),
            notifyParties: party(false),
            actualCustomsOfficeOfFirstEntry: {
                childValidators: {
                    referenceNumber: [validators.required(), validators.exact(8)],
                },
            },
            activeBorderTransportMeans: {
                childValidators: {
                    modeOfTransport: [validators.required(), validators.number(), validators.exact(1)],
                    identificationNumber: [
                        ...(mode === MARITIME ? [validators.required()] : []),
                        validators.maxLength(35),
                    ],
                    typeOfIdentification: [
                        ...(mode === MARITIME ? [validators.required()] : []),
                        validators.number(),
                        validators.maxLength(2),
                    ],
                    conveyanceReferenceNumber: [
                        ...(mode === AIR ? [validators.required()] : []),
                        validators.maxLength(17),
                    ],
                    actualDateAndTimeOfArrival: [validators.required()],
                    estimatedDateAndTimeOfArrival: [],
                },
            },
        },
    };
};

export default ics2ArrivalNotificationValidation;
